import { Col, Row } from "reactstrap";
import styles from "./TwoFactorAuth.module.scss";
import Toggle from "../../../../../components/common/Toggle/Toggle";
import Checkbox from "../../../../../components/common/Checkbox/Checkbox";

const TwoFactorAuth = () => {
  return (
    <div className="py-3">
      <div className={styles["heading"]}>Two-factor Authentication</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={4} xl={3} xxl={2} className="pe-lg-2">Two-factor Verification:</Col>
            <Col lg={8} xxl={10} className="d-flex align-items-center py-1">
              <Toggle />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={4} xl={3} xxl={2} className="pe-lg-2">Verification Method:</Col>
            <Col lg={8} xxl={10}>
              <div className="d-flex gap-3">
                <label className="d-flex align-items-center gap-1">
                  SMS
                  <Checkbox />
                </label>
                <label className="d-flex align-items-center gap-1">
                  Email
                  <Checkbox />
                </label>
              </div>
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={4} xl={3} xxl={2} className="pe-lg-2">Instruction:</Col>
            <Col lg={8} xxl={10}>
              A verification code will be sent to your preferred verification
              method
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default TwoFactorAuth;